import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

const CertificateBarcode: React.FC = () => {
  const qrRef = useRef<HTMLCanvasElement>(null);

  const downloadQR = () => {
    if (!qrRef.current) return;
    const canvas = qrRef.current;
    const url = canvas.toDataURL("image/jpeg", 1.0); // highest quality
    const link = document.createElement("a");
    link.href = url;
    link.download = "certificate-verification-8k.jpg";
    link.click();
  };

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h2 style={{ color: "#4da6ff" }}>📜 Certificate Verification ✅</h2>
      <p>Scan this QR code to verify your certificate:</p>

      {/* Render QR code at very high resolution */}
      <QRCodeCanvas
        value="https://www.growniverse.com/certificate-verification"
        size={7680}              // 8K width in pixels
        bgColor="#ffffff"
        fgColor="#000000"
        level="H"
        includeMargin={true}
        ref={qrRef}
      />

      <button
        onClick={downloadQR}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "#4da6ff",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        ⬇ Download as JPEG (8K)
      </button>
    </div>
  );
};

export default CertificateBarcode;
